"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const hooks_1 = require("../shared/hooks");
const utils_1 = require("../molecules/utils");
const notification_1 = require("../molecules/notification");
const offline_mode_1 = require("../organisms/offline-mode");
const OfflineModal_1 = __importDefault(require("../organisms/modals/OfflineModal"));
const notification_actions_1 = require("../molecules/notification-actions");
const LayoutFC = ({ topBar, sidebar, chat, memberInfo, pageContent, bottomBar, notes, pageMenu, noMember = false, onLayoutRWDChange, notification, isScrollable = true, appCtx, notificationActions }) => {
    const { isMobile } = (0, hooks_1.useRWD)();
    const [mobileLayout, setMobileLayout] = (0, react_1.useState)(isMobile);
    const { isOffline } = (0, hooks_1.useNetwork)();
    (0, react_1.useEffect)(() => {
        if (isMobile === mobileLayout)
            return;
        setMobileLayout(isMobile);
        onLayoutRWDChange && onLayoutRWDChange({ isMobile });
    }, [isMobile]);
    if (noMember) {
        return ((0, jsx_runtime_1.jsxs)(Layout, { "data-member": !noMember, children: [(0, jsx_runtime_1.jsx)(TopBar, { children: topBar }, void 0), (0, jsx_runtime_1.jsxs)(Middle, { isOffline: isOffline, children: [(0, jsx_runtime_1.jsx)(Sidebar, { children: sidebar }, void 0), (0, jsx_runtime_1.jsx)(PageContent, { children: (0, jsx_runtime_1.jsx)(utils_1.NoMember, { appCtx: appCtx }, void 0) }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(BottomBar, { children: bottomBar }, void 0)] }, void 0));
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(Layout, { children: [(0, jsx_runtime_1.jsx)(TopBar, { children: topBar }, void 0), (0, jsx_runtime_1.jsx)(NotificationBar, { children: notification && (0, jsx_runtime_1.jsx)(notification_1.Notification, { ...notification }, void 0) }, void 0), isOffline && ((0, jsx_runtime_1.jsx)(OfflineWrapper, { children: (0, jsx_runtime_1.jsx)(offline_mode_1.OfflineNotification, {}, void 0) }, void 0)), (0, jsx_runtime_1.jsxs)(Middle, { isOffline: isOffline, "data-chat": !!chat, children: [(0, jsx_runtime_1.jsx)(Sidebar, { children: sidebar }, void 0), (0, jsx_runtime_1.jsx)(Chat, { children: chat }, void 0), (0, jsx_runtime_1.jsx)(MemberInfo, { children: memberInfo }, void 0), (0, jsx_runtime_1.jsxs)(PageContent, { "data-with-menu": pageMenu ? true : false, "data-no-bottom": bottomBar ? false : true, children: [!isMobile && ((0, jsx_runtime_1.jsx)(notification_actions_1.NotificationActions, { notifications: notificationActions || [] }, void 0)), pageMenu && (0, jsx_runtime_1.jsx)(PageMenu, { children: pageMenu }, void 0), (0, jsx_runtime_1.jsx)(PageContentWrapper, { isScrollable: isScrollable, children: pageContent }, void 0)] }, void 0), notes && (0, jsx_runtime_1.jsx)(Notes, { children: notes }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(BottomBar, { children: bottomBar }, void 0)] }, void 0), (0, jsx_runtime_1.jsx)(OfflineModal_1.default, {}, void 0)] }, void 0));
};
const TopBar = styled_components_1.default.section `
  align-self: center;
  grid-column: 1;
`;
const NotificationBar = styled_components_1.default.div `
  height: 50px;
  position: absolute;
  top: 49px;
  width: 100%;
  z-index: 1200;

  &:empty {
    display: none;
  }
`;
const Middle = styled_components_1.default.section `
  grid-row: 2;
  grid-column: 1;
  overflow-y: auto;
  display: grid;
  grid-template-rows: minmax(90px, min-content) 1fr;
  grid-template-columns: max-content 1fr 50vw;
  padding-top: ${({ isOffline }) => (isOffline ? "29px" : "0")};

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.laptop}) {
    grid-template-columns: max-content 1fr 52vw;
  }

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.desktopSmall}) {
    grid-template-columns: max-content 1fr 54vw;
  }

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.desktop}) {
    grid-template-columns: max-content 1fr 56vw;
  }

  @media (min-width: ${({ theme }) => theme.utils.breakpoints.desktopLarge}) {
    grid-template-columns: max-content 1fr 59vw;
  }
`;
const Sidebar = styled_components_1.default.section `
  position: relative;
  grid-column: 1;
  grid-row: 1 / 10;
  border-right: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
`;
const Chat = styled_components_1.default.section `
  grid-column: 2;
  grid-row: 2;
  border-right: 1px solid ${({ theme }) => theme.colors.silverBase};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
  overflow-y: auto;
  max-width: 100%;
  z-index: 3;

  &:empty {
    z-index: 1;
  }
`;
const MemberInfo = styled_components_1.default.section `
  grid-column: 2 / 4;
  grid-row: 1;
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
`;
const PageContent = styled_components_1.default.section `
  background-color: ${({ theme }) => theme.colors.silverLighten40};
  border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
  grid-column: 3;
  grid-row: 2;
  padding: 0 1rem 1rem;
  position: relative;
  overflow-y: auto;
  z-index: 2;
`;
const Notes = styled_components_1.default.div `
  grid-column: 3;
  grid-row: 2;
  align-self: end;
  justify-self: start;
  padding-left: 1rem;
`;
const BottomBar = styled_components_1.default.section `
  display: none;
`;
const PageMenu = styled_components_1.default.section `
  display: none;
`;
const PageContentWrapper = styled_components_1.default.div `
  overflow-y: ${({ isScrollable }) => isScrollable ? "auto" : "hidden"};
`;
const OfflineWrapper = styled_components_1.default.div `
  height: 29px;
  grid-row: 2;
  grid-column: 1;
  width: 100%;
  z-index: 20;
`;
const Layout = styled_components_1.default.section `
  height: 100%;
  width: 100%;
  display: grid;
  background-color: white;
  grid-template-rows: 48px 1fr;
  grid-template-columns: 1fr;

  [data-chat="false"] {
    ${PageContent} {
      grid-column: 1 / 4;
    }
  }

  &[data-member="false"] {
    ${Middle} {
      border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
      grid-template-rows: 1fr;
      grid-template-columns: max-content 1fr;
      background-color: ${({ theme }) => theme.colors.silverLighten70};
      @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
        grid-template-columns: 1fr;
      }
    }
    ${Sidebar} {
      border-top: none;
    }

    ${BottomBar} {
      border-top: 1px solid ${({ theme }) => theme.colors.silverBase};
    }
    ${PageContent} {
      border-top: none;
      justify-self: center;
      align-self: center;
      grid-column: unset;
      grid-row: unset;
      border-bottom: none;
      padding: 1rem;
      position: relative;
    }
  }

  @media (max-width: ${({ theme }) => theme.utils.breakpoints.mobile}) {
    position: relative;
    grid-template-rows: 50px auto max-content;
    grid-template-columns: auto;

    ${Middle} {
      grid-template-rows: auto;
      grid-template-columns: auto;
      grid-column: 1;
      grid-row: 2;
    }

    ${Sidebar} {
      position: absolute;
      left: -100%;
      top: 0;
      border-top: none;
      grid-column: none;
      grid-row: none;
      z-index: 5;
    }
    ${MemberInfo} {
      grid-column: 1;
      grid-row: 1;
      display: none;
    }
    ${Chat} {
      grid-column: 1;
      grid-row: 1;
      border-right: none;
      z-index: 1;
    }
    ${PageMenu} {
      display: block;
      background-color: ${({ theme }) => theme.colors.whiteBase};
      padding-top: 0;
      max-width: 100vw;
    }
    ${PageContent} {
      max-width: 100vw;
      grid-column: 1;
      grid-row: 1 / 2;
      border-bottom: 1px solid ${({ theme }) => theme.colors.silverBase};
      padding: 0;

      ${PageContentWrapper} {
        padding-bottom: 1rem;
      }

      &[data-no-bottom="true"] {
        ${PageContentWrapper} {
          padding-bottom: 0;
        }
      }
      &[data-with-menu="true"] {
        display: grid;
        grid-template-columns: auto;
        grid-template-rows: max-content auto;
      }
    }
    ${BottomBar} {
      grid-column: 1;
      grid-row: 3;
      display: block;
      align-self: center;
      vertical-align: middle;
      &:empty {
        display: none;
      }
      &:not(:empty) {
        height: 50px;
      }
    }
    ${Notes} {
      display: none;
    }
  }
`;
exports.default = LayoutFC;
//# sourceMappingURL=GridLayout.js.map